import Slider from "react-slick";
import img1 from "../../assets/images/home/mom-1.JPG";
import img2 from "../../assets/images/home/mom-2.jpeg";
import img3 from "../../assets/images/home/mom-3.jpeg";
import SectionTitle from "../../components/SectionTitle";

const OurMoments = () => {
  const imgs = [img2, img1, img3];
  const data = [
    "/img/moments/1.JPG",
    "/img/moments/2.jpeg",
    "/img/moments/3.JPG",
    "/img/moments/4.JPG",
    "/img/moments/5.jpeg",
    "/img/moments/6.png",
    "/img/moments/7.JPG",
    "/img/moments/8.JPG",
    "/img/moments/9.JPG",
    "/img/moments/10.png",
    "/img/moments/11.JPG",
    "/img/moments/12.png",
    "/img/moments/13.png",
    "/img/moments/14.PNG",
    "/img/moments/15.jpeg",
    "/img/moments/16.png",
    "/img/moments/17.png",
    "/img/moments/18.png",
    "/img/moments/19.JPG",
    "/img/moments/20.JPG",
    "/img/moments/21.JPG",
    "/img/moments/22.JPG",
    "/img/moments/23.JPG",
    "/img/moments/24.jpeg",
    "/img/moments/25.png",
    "/img/moments/26.jpg",
    "/img/moments/27.JPG",
    "/img/moments/28.jpeg",
    "/img/moments/29.jpg",
    "/img/moments/30.png",
    "/img/moments/31.JPG",
    "/img/moments/32.JPG",
    "/img/moments/33.jpg",
    "/img/moments/34.jpg",
    "/img/moments/35.JPG",
    "/img/moments/36.jpg",
    "/img/moments/37.jpg",
    "/img/moments/38.jpg",
    "/img/moments/39.JPG",
    "/img/moments/40.JPG",
    "/img/moments/41.JPG",
    "/img/moments/42.jpeg",
    "/img/moments/43.JPG",
    "/img/moments/44.jpeg",
    "/img/moments/45.JPG",
    "/img/moments/46.jpg",
    "/img/moments/47.jpeg",
    "/img/moments/48.jpeg",
    "/img/moments/49.jpeg",
    "/img/moments/50.jpeg",
    "/img/moments/51.jpeg",
    "/img/moments/52.jpeg",
  ];

    const awardsSetting = {
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: false,
    autoplay:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };


  return (
    <>
        <div className="react-clients react-clientso home-testimonial py-5 ">
      <div className="container">
        <SectionTitle Title="Our" subtitle="Moments" />
        <div
          className="client-slider m-0 col-12 wow animate_fadeInUp mb-md-5"
          data-wow-duration="0.3s"
        >
          <Slider {...awardsSetting}>
            {data?.map((item, idx) => (
              <div key={idx} className="m-2 ">
                <div className="awards_card bg-white mx-2 shadow">
                  <img
                    src={item}
                    width={320}
                    height={320}
                    style={{
                      objectFit: "cover",
                      height: "100%",
                      width: "100%",
                    }}
                    className=" h-full w-full rounded"
                    alt=""
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
      {/* <section className="container py-4 mb-4">
        <h2 className="mb-5 text-center display-3 text-black fw-bold">
          Our{" "}
          <strong style={{ color: "#FE7743" }} className=" fw-semibold">
            Moments
          </strong>
        </h2>
        <div className="row row-cols-1 gy-4 row-cols-md-3  align-items-center">
          {data?.map((item, idx) => (
            <div key={idx} className="col">
              <img src={item} alt="" />
            </div>
          ))}
        </div>
      </section> */}
    </>
  );
};

export default OurMoments;
